import { apiClient } from '@/api/client';
import type { UserPreferencesWire } from '../schemas/user-preferences';

export async function getUserPreferences(): Promise<UserPreferencesWire> {
  return apiClient.get<UserPreferencesWire>('/api/user/preferences');
}

export async function updateUserPreferences(
  data: { cuisine_preferences?: string[]; dietary_restrictions?: string[] }
): Promise<UserPreferencesWire> {
  return apiClient.patch<UserPreferencesWire>('/api/user/preferences', data);
}
